import create from 'zustand';
import { nanoid } from 'nanoid';

const NOTIFICATIONS_INITIAL = {
	notifications: []
};

export const useNotificationStore = create(set => ({
	notifications: [],

	// Create notification
	createNotification: (type, message) => set(state => ({
		notifications: [...state.notifications, { id: nanoid(), type, message }]
	})),

	// Remove notification
	removeNotification: (id) => set(state => ({
		notifications: state.notifications.filter(notification => notification.id !== id)
	})),

	// Reset app's state
	onReset: () => set({
		...NOTIFICATIONS_INITIAL
	})
}));